import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  contactBg: {
    //background: 'var(--color-neutral-gray-light)'
    minHeight: 500,
    width: '100%',
    color: 'white',
},
contactContainer: {
    padding: '50px 10vw',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '50px 0',
    }
},
contactHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '3px dashed #FFFFFF',
    margin: '0px auto',
    width: '180px',
    height: '65px',
    color: 'white',
    letterSpacing: '1px',
    textTransform: 'uppercase',
},
input: {
    width: '100% !important',
    height: '35px',
    margin: '15px 0',
    background: 'transparent',
    border: 'none',
    borderBottom: '3px solid white',
    borderLeft: '3px solid white',
    color: '#FFFFFF',
    '&:focus': {
      color: 'honeydew'
    },
      '&::placeholder': {
      fontSize: '15px',
    padding: '10px',
    textTransform: 'uppercase',
    color: 'var(--color-neutral-gray-dark)',
    }
},
textarea: {
    width: '100% !important',
    height: '100px',
    color: '#FFFFFF',
    margin: '15px 0',
    background: 'transparent',
    border: 'none',
    borderBottom: '3px solid #FFFFFF',
    borderLeft: '3px solid #FFFFFF',
    '&::placeholder': {
      fontSize: '15px',
    padding: '10px',
    textTransform: 'uppercase',
    color: 'var(--color-neutral-gray-dark)',
    }
},
contactBtn: {
    height: '40px',
    width: '130px',
    textTransform: 'uppercase',
    fontSize: '20px',
    letterSpacing: '1px',
    fontWeight: 'bold',
    marginTop: '20px',
    background: 'none',
    border: 'none',
    borderLeft: '3px solid #FFFFFF',
    borderRight: '3px solid #FFFFFF',
    boxShadow: '1px 1px',
    padding: '5px',
    color: '#FFFFFF',
    '&:hover': {
     boxShadow: '5px 5px 10px',
     transform: 'scale(1.1)'
}
}
}));

export default useStyles;
